import { useState } from 'react';

const WA_NUMBER = '34696342047';
const WA_MESSAGE = encodeURIComponent('Hola, me gustaría solicitar información sobre sus servicios de mediación.');
const WA_URL = `https://wa.me/${WA_NUMBER}?text=${WA_MESSAGE}`;

export default function WhatsAppButton() {
  const [hovered, setHovered] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-[9998] flex items-center justify-end gap-3">
      {/* Tooltip */}
      <div
        className={`transition-all duration-300 ${
          hovered ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-2 pointer-events-none'
        }`}
      >
        <div className="bg-[#1B3A5C] text-white text-xs font-medium px-3.5 py-2 rounded-full whitespace-nowrap">
          Escríbenos por WhatsApp
          <span className="absolute right-[-5px] top-1/2 -translate-y-1/2 w-0 h-0 border-t-4 border-b-4 border-l-[6px] border-t-transparent border-b-transparent border-l-[#1B3A5C]" />
        </div>
      </div>

      {/* Button */}
      <a
        href={WA_URL}
        target="_blank"
        rel="nofollow noopener noreferrer"
        aria-label="Contactar por WhatsApp"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        className="relative w-14 h-14 flex items-center justify-center rounded-full bg-[#25D366] hover:bg-[#1ebe5d] transition-colors duration-200 cursor-pointer"
        style={{ boxShadow: '0 4px 20px rgba(37,211,102,0.40)' }}
      >
        {/* Pulse ring */}
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-25" />
        <i className="ri-whatsapp-line text-white text-2xl relative z-10" />
      </a>
    </div>
  );
}
